<template>
  <div class="v-select car-v-select" :class="{'vs--open': showDropDown}" v-on-clickaway="hideDropDown">
    <div class="vs__dropdown-toggle" @click="toggle">
      <div class="vs__selected-options">
        <span class="vs__selected">{{ selectedOption | optionTranslate }}</span>
        <input class="vs__search">
      </div>
      <div class="vs__actions"></div>
    </div>
    <ul class="vs__dropdown-menu">
      <li v-for="(option, index) in options"
           :key="index"
           @click="selectOption(option)"
           class="vs__dropdown-option">
        {{ option | optionTranslate }}
      </li>
    </ul>
  </div>
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],
  name: 'DropDown',
  props: {
    selectedOption: {
      required: true
    },
    options: {
      required: true
    },
    translationKeyPrefix: {
      default: ''
    }
  },
  data: function () {
    return {
      showDropDown: false
    }
  },
  methods: {
    hideDropDown: function() {
      this.showDropDown = false;
    },
    selectOption(value) {
      this.$emit('change', value);
      this.hideDropDown();
    },
    toggle() {
      this.showDropDown = !this.showDropDown;
    }
  }
};
</script>
